import React, { useMemo } from "react";

import Form from "antd/es/form";
import { defineMessages, useIntl } from "react-intl";

import { SelectField } from "@mapmycustomers/ui";

import MultiSelectActivityTypeField from "@app/component/input/MultiSelectActivityTypeField";
import SourceType, { getSourceTypeDisplayName, SupportedSources } from "@app/enum/SourceType";
import CardConfigurationProps from "@app/scene/dashboard/types/CardConfigurationProps";

const messages = defineMessages({
  activityTypes: {
    id: "dashboard.editModal.criteria.activitiesLogged.activityTypes",
    defaultMessage: "Activity Type(s)",
    description:
      "Title of the Activity Types field in a criteria form in Edit Activities Logged Modal on Dashboard",
  },
  activityTypesPlaceholder: {
    id: "dashboard.editModal.criteria.activitiesLogged.activityTypes.placeholder",
    defaultMessage: "All Types",
    description:
      "Placeholder of the Activity Types field in a criteria form in Edit Activities Logged Modal on Dashboard",
  },
  sources: {
    id: "dashboard.editModal.criteria.activitiesLogged.sources",
    defaultMessage: "Source(s)",
    description:
      "Title of the Sources field in a criteria form in Edit Activities Logged Modal on Dashboard",
  },
  sourcesPlaceholder: {
    id: "dashboard.editModal.criteria.activitiesLogged.sources.placeholder",
    defaultMessage: "Any Source",
    description:
      "Placeholder of the Sources field in a criteria form in Edit Activities Logged Modal on Dashboard",
  },
});

interface Props extends CardConfigurationProps {}

const CriteriaFormComponent: React.FC<Props> = ({ disabled }) => {
  const intl = useIntl();

  const sourceOptions = useMemo(
    () =>
      Object.values(SourceType).map((value) => ({
        label: getSourceTypeDisplayName(intl, value),
        value,
      })),
    [intl]
  );

  return (
    <div>
      <Form.Item
        label={intl.formatMessage(messages.activityTypes)}
        name={["criteria", "activityTypeIds"]}
      >
        <MultiSelectActivityTypeField
          allowClear
          locked={disabled}
          placeholder={intl.formatMessage(messages.activityTypesPlaceholder)}
          showArrow
        />
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.sources)} name={["criteria", "sources"]}>
        <SelectField<SupportedSources>
          allowClear
          locked={disabled}
          mode="multiple"
          options={sourceOptions}
          placeholder={intl.formatMessage(messages.sourcesPlaceholder)}
          showArrow
        />
      </Form.Item>
    </div>
  );
};

export default CriteriaFormComponent;
